export const CAMPAIGN_FLAG_NAMES = {
  GOOGLE_ADS_TEST_MCC: 'ff-cam-1898-google-ads-test-mcc',
  CAMPAIGNS: 'ff-cam-26-campaigns',
  CAMPAIGN_CANVAS_OUTLINES: 'ff-cam-577-campaign-canvas-outlines',
  CAMPAIGNS_COMPONENT_LIBRARY_AUTHORING:
    'ff-cam-358-internal-campaigns-authoring',
  COMPONENT_BROWSER_SELECT_SOURCE: 'ff-cam-419-component-browser-select-source',
  VARIABLE_MODE_PROPS_CREATION: 'ff-cam-variable-mode-props-creation',
  HUBSPOT_INTELLIMIZE_SYNC: 'ff-cam-hubspot-sync',
  MARKETO_INTELLIMIZE_SYNC: 'ff-cam-marketo-sync',
  EXPOSE_NAVIGATOR_PANEL_IN_CAMPAIGNS:
    'ff-cam-585-expose-navigator-panel-in-campaigns',
  CAMPAIGNS_PUBLIC_API_ENABLED: 'ff-cam-819-campaigns-public-api',
  CAMPAIGNS_SALESFORCE_INTEGRATION:
    'ff-wfa-2277-campaigns-salesforce-integration',
  CAMPAIGNS_PERSONALIZATION: 'ff-campaigns-personalization',
  CAMPAIGNS_ANALYTICS_AGENT: 'ff-wfa-2259-campaigns-analytics-agent',
  CAMPAIGNS_PIPELINE_REPORTING: 'ff-wfa-2267-campaigns-pipeline-reporting',
  CAMPAIGN_PAGE_AUDIT_SCHEDULER: 'ff-wfa-2402-campaign-page-audit-scheduler',
  CAMPAIGNS_SHOW_UNSUPPORTED_RECOMMENDATIONS:
    'ff-wfa-2542-campaigns-show-unsupported-recommendations',
  CAMPAIGN_PAGE_AUDIT_AI_CREDITS: 'ff-wfa-2654-campaign-page-audit-ai-credits',
  CAMPAIGN_PAGE_AUDIT_REFRESH_BATCH:
    'ff-wfa-2582-campaign-page-audit-refresh-batch',
  CAMPAIGNS_SEO_SETTINGS: 'ff-cam-2074-campaigns-seo-settings',
  CAMPAIGNS_TYPOGRAPHY_EDITING: 'ff-cam-1665-typography-role-editing',
  CAMPAIGNS_CUSTOMER_INSTRUCTIONS: 'ff-cam-1812-customer-instructions',
  CAMPAIGNS_ONBOARDING: 'ff-cam-2229-campaigns-onboarding',
  CAMPAIGNS_COMPONENTIZATION_TOGGLE:
    'ff-cam-campaign-build-mode-static-editing',
} as const;

export const CAMPAIGN_DYNAMIC_CONFIG_NAMES = {
  CAMPAIGN_GENERATION: 'dc-cam-273-campaigns-generation',
  AI_CAMPAIGNS_CHAT_CONFIGS: 'ai-campaigns-chat-configs',
  PAGE_GENERATION_MODE: 'dc-cam-885-page-generation-config',
  CAMPAIGN_ANALYTICS_PUBLIC_CONCURRENCY_LIMIT:
    'dc-cam-1323-campaign-analytics-public-concurrency-limit',
  CAMPAIGN_PAGE_AUDIT_TRAFFIC: 'dc-wfa-2622-campaign-audit-traffic',
} as const;
